export default __webpack_public_path__ + "static/media/green01.14ecc29c.jpg";